import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  hexToRgb,
  Stack,
  Typography
} from '@mui/material'

import { InspectionStatusWithEntries } from '../../models/inspections'
import { EntryInfoStatusEnum } from '../../sdk'
import { InspectionEntryStatusChip } from './InspectionEntryStatusChip'

export const NotPassedEntriesListWrapper = ({
  status,
  children
}: {
  status: InspectionStatusWithEntries
  children: React.ReactNode
}) => {
  return (
    <Accordion
      defaultExpanded={true}
      variant="outlined"
      disableGutters
      sx={{ borderRadius: '4px', '&:before': { display: 'none' } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          variant="h5"
          color={
            status.id === EntryInfoStatusEnum.NotInspected
              ? 'black'
              : hexToRgb('#' + status.info!.color!)
          }
          width="90%">
          {`${status.entries.length} ${status.info!.title}`}
        </Typography>
        <InspectionEntryStatusChip status={status} />
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1} sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {children}
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
